module.exports = __webpack_public_path__ + "media/images/noaccountsloaderbc-5b6644c5.gif";